export enum ExecutedStateLayerEnum{
  PLANNED  = 'Fiber_aantal_operatoren_gepland_Lambert72',
  EXECUTED = 'Fiber_aantal_operatoren_Lambert72',
}
